import { render, staticRenderFns } from "./AdminsDataTable.vue?vue&type=template&id=7b114da5"
import script from "./AdminsDataTable.vue?vue&type=script&lang=js"
export * from "./AdminsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports